import { array, enums, object, string } from "superstruct";

import { REWARDS_CUSTOMER_DELAYED_REWARDS_TYPES } from "../types";
import { RewardsCustomerRewardsActivitySchema } from "./RewardsCustomerRewardsActivitySchema";

export const RewardsCustomerDelayedRewardsSchema = object({
    type: enums(Object.values(REWARDS_CUSTOMER_DELAYED_REWARDS_TYPES)),
    rewardScheduledAt: string(),
    earningRule: RewardsCustomerRewardsActivitySchema,
});

export const RewardsCustomerDelayedRewardsResponseSchema = object({
    delayedRewards: array(RewardsCustomerDelayedRewardsSchema),
});
